
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSReturnItemsGrid extends Serenity.EntityGrid<POSReturnItemsRow, any> {
        protected getColumnsKey() { return 'Retail.POSReturnItems'; }
        protected getDialogType() { return POSReturnItemsDialog; }
        protected getIdProperty() { return POSReturnItemsRow.idProperty; }
        protected getInsertPermission() { return POSReturnItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSReturnItemsRow.localTextPrefix; }
        protected getService() { return POSReturnItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}